import axios from '@/utils/axiosHelper';

// 初始化
export const onGetInitDataAPI = (params) => {
  return axios({
    url: '/demon/festival/init',
    method: 'GET',
    params: { ...params, app_id: 67 }
  }, { interceptResultCode: false });
};
// 获取日活
export const onGetDayActiveAPI = () => {
  return axios({
    url: '/demon/festival/activation',
    method: 'GET',
  }, { interceptResultCode: false });
};
// 签到
export const onGetSignAPI = () => {
  return axios({
    url: '/demon/festival/sign',
    method: 'POST',
  }, { interceptResultCode: false });
};
// 下载地址
export const onDownloadApi = (params) => {
  return axios({ url: '/get_url?game_id=67', method: 'GET', params }, { interceptResultCode: false });
};
// 每日分享奖励
export const onGetShareRewardAPI = () => {
  return axios({
    url: '/demon/festival/share',
    method: 'GET',
  }, { interceptResultCode: false });
}




// WEBPACK FOOTER //
// ./src/pages/servitor/nySign/api.js